// extracted by mini-css-extract-plugin
export default {"logoBurger":"Burger_logoBurger__dCnN-","buttonLogin":"Burger_buttonLogin__dFiFa","user":"Burger_user__Ia50B"};